import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PASSWORD_MIN_LENGTH } from '../../ui';

interface PasswordPolicyResponse {
  readonly minLength: number;
}

/**
 * Lunghezza minima delle nuove password, da `GET /api/auth/password-policy`. Vale 12 (FR-003)
 * finché la risposta non arriva o se fallisce; in sviluppo il server può configurarla più bassa.
 */
@Injectable({ providedIn: 'root' })
export class PasswordPolicyService {
  private readonly http = inject(HttpClient);
  private readonly minLengthValue = signal(PASSWORD_MIN_LENGTH);

  readonly minLength = this.minLengthValue.asReadonly();

  /** Legge la policy all'avvio: i moduli la usano quando creano i validatori. */
  async load(): Promise<void> {
    try {
      const policy = await firstValueFrom(
        this.http.get<PasswordPolicyResponse>('/api/auth/password-policy'),
      );
      if (Number.isInteger(policy.minLength) && policy.minLength > 0) {
        this.minLengthValue.set(policy.minLength);
      }
    } catch {
      // Si resta sul minimo predefinito: il server convalida comunque.
    }
  }
}
